import { render, staticRenderFns } from "./AppRodape.vue?vue&type=template&id=2d72ece6&"
import script from "./AppRodape.vue?vue&type=script&lang=js&"
export * from "./AppRodape.vue?vue&type=script&lang=js&"
import style0 from "./AppRodape.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports